import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useParams } from 'react-router-dom';
import Spinner from '../ogComponent/spinner';
import { IconDownload } from '@tabler/icons-react';

export default function Download() {
  const [studentName, setStudentName] = useState('');
  const [courseName, setCourseName] = useState('');
  const [description, setDescription] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [date, setDate] = useState('');
  const [receipt, setReceipt] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();

  // Access permissions array from Redux store
  const permissions = useSelector((state) => state.emp.permissions);

  const pagePermissions = ["downloadfeerecieptID"];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = localStorage.getItem('accessToken');

        if (!accessToken) {
          throw new Error('Access token not found in local storage');
        }

        const response = await fetch(
          `${process.env.REACT_APP_API}/api/course/enrollments/${id}`,
          {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${accessToken}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        setStudentName(data.student.full_name);
        setCourseName(data.course.course_name);
        setDescription(data?.description);
        setPhoneNumber(data.student.contact_number);
        setDate(data.enrollment_date);
        setReceipt(data.receipt_number);
        setPaymentMethod(data.payment_method);
        setAmount(data.amount_paid);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError(error.message);
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleDownload = () => {
    const input = document.getElementById('receipt');
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 10, 10, imgWidth, imgHeight);
      pdf.save(`${studentName.replace(/\s+/g, '_')}_fee_receipt.pdf`);
    });
  };

  if (loading) return <Spinner />;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container my-4">
      <div id="receipt" className="card shadow-sm mx-auto" style={{ maxWidth: '500px' }}>
        <div className="card-header text-white text-center" style={{ backgroundColor: '#dbaa4f', borderBottom: 'none' }}>
          <h3 className="mb-0 fw-semibold">Prosevo Technologies</h3>
        </div>
        <div className="card-header pt-1 d-flex justify-content-end pt-0 text-white text-center" style={{ backgroundColor: '#dbaa4f' }}>
          <div className='text-start w-100 d-flex justify-content-between' style={{ fontSize: '12px' }}>
            <p className='mb-0'>Date: {date}</p>
            <p className='mb-0'>Receipt No: {receipt}</p>
          </div>
        </div>
        <div className="card-body">
          <table className="table table-bordered">
            <tbody>
              {[
                { label: "Student Name", value: studentName },
                { label: "Course Name", value: courseName },
                { label: "Description", value: description || "N/A" },
                { label: "Phone Number", value: phoneNumber },
                { label: "Payment Method", value: paymentMethod },
                { label: "Amount", value: `₹${amount}` }
              ].map((item, index) => (
                <tr key={index}>
                  <td className="bg-light fw-semibold">{item.label}</td>
                  <td>{item.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className='d-flex justify-content-end px-3'>
            <img src="/assets/logo_sign.png" alt="sign" style={{ width: '100px' }} />
          </div>
          <div className='d-flex align-items-center flex-column w-100 mt-2'>
            <p className='mb-0' style={{ fontSize: '12px' }}>Cheerangan Tower, Zudio Building - Vengara, Malappuram.</p>
            <p className='mb-0' style={{ fontSize: '12px' }}>Phone: +91 8891341818 | Email: Contact@prosevo.com</p>
          </div>
        </div>
      </div>

      {permissions.includes("downloadfeerecieptID") && (
        <div className="w-100 d-flex justify-content-center mt-3">
          <button
            className="btn btn-success px-4 d-flex justify-content-center align-items-center gap-2"
            onClick={handleDownload}
            aria-label="Download Receipt"
          >
            Download Receipt <IconDownload stroke={2} size={20} />
          </button>
        </div>
      )}
    </div>
  );
}